export default __webpack_public_path__ + "static/media/IconDesc_Bow.256.570bc0a4.png";